import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import React, {useState} from 'react';
import { useLocation } from 'react-router-dom';
import ProductsToPayList from '../components/products-to-pay-list';
import { isMobile } from 'react-device-detect';
import { Member } from '../models/member';
import { useAuth } from '../components/auth';
import BankTransfer from "../components/bank-transfer";
import { MemberProductStatus } from '../models/periodic-product-payment';
import PaywayCheckout from '../components/payway-checkout';
import { PostPaymentRequest } from '../models/web/post-payment-request';
import MercadoPago from '../components/mercado-pago';
import { PAYMENT_METHOD_NAME_CARD, PAYMENT_METHOD_NAME_MERCADO_PAGO } from '../constants';

function PaymentPage(): JSX.Element {
  const auth = useAuth();
  const member = auth.user.selectedMember as Member;
  const { state } = useLocation();
  const paymentMethod = state.paymentMethod as string;
  const productsToPay = state.productsToPay as MemberProductStatus[];
  const [total, setTotal] = useState<number>(0);

  if (member == null || productsToPay.length === 0) {
    return <></>;
  }

  const payment: PostPaymentRequest = {
    memberId: member.id,
    methodId: state.paymentMethod,
    paymentDetails: productsToPay.map(product => ({
      productId: product.product.id!,
      price: product.remainingPrice,
      discriminator: product.product.discriminator
    })),
    comments: 'Abonado a través de la sede virtual'
  }

  return (
    <VStack
      width={['full', 500, 'full']}
      align="center"
      spacing={3}
      padding={[3, 3, 10]}
      paddingTop={10}
    >
      <VStack
        width={['full', 'full', '80%']}
        align="flex-start"
        spacing={[5, 5, 3]}
      >
        <Heading>Confirmación del pago</Heading>
        <Text>
          Por favor, revisá atentamente el detalle de lo que vas a abonar:
        </Text>
        <ProductsToPayList
          membershipFeesToPay={productsToPay}
          tableSize={isMobile ? 'sm' : 'md'}
          setTotal={setTotal}
          variant="boxed"
        />
        <Box marginTop={5} width="100%">
          {(() => {
            switch (paymentMethod) {
              case PAYMENT_METHOD_NAME_MERCADO_PAGO:
                return (
                  <MercadoPago
                    memberId={member.id}
                    memberNumber={member.memberNumber}
                    productsToPay={productsToPay}
                  />
                );
              case PAYMENT_METHOD_NAME_CARD:
                return (
                  <VStack align="center" width="100%">
                    <PaywayCheckout payment={payment} />
                  </VStack>
                );
              default:
                return <BankTransfer total={total} productsToPay={productsToPay} memberId={member.id} />;
            }
          })()}
        </Box>
      </VStack>
    </VStack>
  );
}

export default PaymentPage;
